import { Controller } from 'stimulus'
import $ from 'jquery'

import './blog_posts_component.scss'

export default class extends Controller {
  static values = { url: String }

  connect() {
    if (!this.hasUrlValue) return

    $(this.element).on('click.blog-posts-paginator', '.pagination a', (e) => {
      e.preventDefault()
      const page = new URL(e.currentTarget.href).searchParams.get('page') || 1
      this.#loadPage(page)
    })
  }

  disconnect() {
    $(this.element).off('.blog-posts-paginator')
  }

  #loadPage(page) {
    this.#showOverlay()

    $.ajax({
      type: 'GET',
      url: this.urlValue,
      data: { page },
      global: false,
      cache: false,
    }).then((data) => {
      $(this.element).replaceWith(data.content)
    }).catch((e) => {
      this.#hideOverlay()
      console.error('Error loading blog posts page:', e)
    })
  }

  #showOverlay() {
    const overlay = document.createElement('div')
    overlay.className = 'blog-posts-loading-overlay'
    overlay.style.cssText = 'position:absolute;inset:0;background:rgba(255,255,255,0.6);display:flex;align-items:center;justify-content:center;z-index:10;border-radius:inherit'
    overlay.innerHTML = '<div class="blog-posts-loading-spinner" style="width:2rem;height:2rem;border:3px solid #e5e7eb;border-top-color:#6b7280;border-radius:50%;animation:blog-posts-spin 0.7s linear infinite"></div>'
    this.element.style.position = 'relative'
    this.element.appendChild(overlay)
  }

  #hideOverlay() {
    this.element.querySelector('.blog-posts-loading-overlay')?.remove()
  }
}
